import { render, staticRenderFns } from "./programa-contrato-pdf.vue?vue&type=template&id=087d10f6"
import script from "./programa-contrato-pdf.vue?vue&type=script&lang=js"
export * from "./programa-contrato-pdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports